import { cn } from '@shared/components/shadcn';
import type { NumberedCircleProps } from './types';

/**
 * Renders a numbered circle component with accessibility features.
 * Displays a number inside a circular background, commonly used for step indicators.
 */
function NumberedCircle({ number, className, 'data-testid': dataTestId, ...rest }: NumberedCircleProps) {
  const DEFAULT_ARIA_LABEL = `Step ${number}`;
  const DEFAULT_ROLE = 'img';
  const { 'aria-label': ariaLabel, role, ...otherRest } = rest;

  return (
    <div
      className={cn(
        'w-8 h-8 bg-accent-green btn-label-s flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-accent-green focus:ring-offset-2',
        className
      )}
      data-testid={dataTestId}
      role={(role as React.AriaRole) ?? DEFAULT_ROLE}
      aria-label={typeof ariaLabel === 'string' ? ariaLabel : DEFAULT_ARIA_LABEL}
      {...otherRest}
    >
      {number}
    </div>
  );
}

export { NumberedCircle };
